// Authentication service that works with Redux store
// This connects to our Redux implementation

export const getUserData = () => {
  // Get user data from localStorage (set by Redux)
  try {
    const user = localStorage.getItem('user');
    if (user) {
      const userData = JSON.parse(user);
      return {
        id: userData.id,
        firstName: userData.first_name,
        lastName: userData.last_name,
        email: userData.email,
        profileImage: userData.profile_image || null,
        role: userData.user_type || 'JetSetter'
      };
    }
  } catch (error) {
    // Error parsing user data
  }
  return null;
};

export const getUserRole = () => {
  // Get user role from stored user data
  const userData = getUserData();
  return userData?.role || 'JetSetter';
};

export const setUserRole = (role) => {
  // This is handled by Redux, but keeping for compatibility
  // console.warn('setUserRole is deprecated, use Redux actions instead');
};

export const isAuthenticated = () => {
  // Check if user is logged in by checking for token and user data
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  return !!(token && user);
};

export const login = (role = 'JetSetter') => {
  // This is handled by Redux, but keeping for compatibility
  // console.warn('login is deprecated, use Redux loginUser action instead');
};

export const logout = () => {
  // This is handled by Redux, but keeping for compatibility
  // console.warn('logout is deprecated, use Redux logoutUser action instead');
};

export const getDashboardRoute = (role) => {
  switch (role) {
    case 'Airliner':
      return '/airliner';
    case 'JetSetter':
      return '/jetsetter';
    case 'Admin':
    case 'SubAdmin':
      return '/admin';
    default:
      return '/search-flight';
  }
};

// Mock functions for AuthContext compatibility
export const getCurrentUser = async () => {
  const userData = getUserData();
  if (userData) {
    return {
      id: userData.id,
      name: `${userData.firstName} ${userData.lastName}`,
      email: userData.email,
      role: userData.role
    };
  }
  throw new Error('Not authenticated');
};

export const register = async (userData) => {
  // This is handled by Redux, but keeping for compatibility
  // console.warn('register is deprecated, use Redux registerUser action instead');
  throw new Error('Use Redux registerUser action instead');
};

// Default export with all functions
const authService = {
  getUserData,
  getUserRole,
  setUserRole,
  isAuthenticated,
  login,
  logout,
  getDashboardRoute,
  getCurrentUser,
  register
};

export default authService;